const IGNORED_PATH_PREFIXES = [
  '/app',
  '/fr/app',
  '/api',
  '/_nuxt'
]

const IGNORED_EXACT_PATHS = new Set([
  '/favicon.ico',
  '/robots.txt',
  '/sitemap.xml'
])

const STATIC_ASSET_PATTERN = /\.[a-z0-9]{1,8}$/i

const collapseSlashes = (value: string) => value.replace(/\/{2,}/g, '/')

export const normalizeTrackedPagePath = (input: string | null | undefined): string | null => {
  if (!input || typeof input !== 'string') {
    return null
  }

  const trimmed = input.trim()
  if (!trimmed) {
    return null
  }

  let path: string

  try {
    const parsed = trimmed.startsWith('http://') || trimmed.startsWith('https://')
      ? new URL(trimmed)
      : new URL(trimmed.startsWith('/') ? trimmed : `/${trimmed}`, 'https://kendrick.paris')

    path = parsed.pathname || '/'
  } catch {
    return null
  }

  path = collapseSlashes(path)

  if (path.length > 1) {
    path = path.replace(/\/+$/, '')
  }

  if (!path.startsWith('/')) {
    path = `/${path}`
  }

  if (IGNORED_EXACT_PATHS.has(path)) {
    return null
  }

  if (IGNORED_PATH_PREFIXES.some(prefix => path === prefix || path.startsWith(`${prefix}/`))) {
    return null
  }

  if (STATIC_ASSET_PATTERN.test(path)) {
    return null
  }

  return path || '/'
}

export const getHourlyBucketIso = (date = new Date()): string => {
  const bucket = new Date(date)
  bucket.setUTCMinutes(0, 0, 0)
  return bucket.toISOString()
}

export const parseStatsWindowHours = (input: unknown, fallback = 72): number => {
  const parsed = Number.parseInt(String(input ?? fallback), 10)

  if (!Number.isFinite(parsed) || parsed <= 0) {
    return fallback
  }

  return Math.min(Math.max(parsed, 1), 24 * 90)
}

